import { CorrectIcon } from "@Icons/MainIcons";
import { Card, Chip, IconHolder, Tag, GiftcardsDecor, DiscountsDecor, HotelDecor, PaymentsDecor, TicketDecor } from "@Components/Decor";
import { BoltIcon, HeartIcon, StarIcon as Star } from "@Icons/MainIcons";
import { useTranslation } from "react-i18next";
import { MenuItemType } from "src/store/persistedClientData";
import { ComponentType } from "react";

function EarnedTag() {
  const { t } = useTranslation();
  return (
    <Tag
      title={t("Landing.hero.earnedTitle")}
      subtitle={t("Landing.hero.earnedSubtitle")}
      icon={<Star className="bg-background-primary-lighter text-font-active h-full w-full rounded-full p-2.5" />}
    />
  );
}

function UnlockedCard() {
  const { t } = useTranslation();
  return (
    <Card
      title={t("Landing.hero.unlockedTitle")}
      subtitle={
        <div className="flex items-center gap-1">
          <CorrectIcon />
          {t("Landing.hero.unlockedSubtitle")}
        </div>
      }
    />
  );
}

function FastTag() {
  const { t } = useTranslation();
  return (
    <Tag
      title={t("Landing.hero.fastTitle")}
      subtitle={t("Landing.hero.fastSubtitle")}
      icon={<BoltIcon className="bg-background-primary-lighter text-font-active h-full w-full rounded-full p-2" />}
    />
  );
}

function StarHolder() {
  return <IconHolder icon={<Star className="aspect-square w-8 p-2" />} />;
}

function TreatChip() {
  const { t } = useTranslation();
  return (
    <Chip
      title={t("Landing.hero.treat")}
      icon={<HeartIcon className="h-3 w-3 text-white" />}
      className="bg-background-primary! text-white! outline-none!"
    />
  );
}

type DecorSelection = {
  main: ComponentType;
  secondary: ComponentType;
  x: string;
  y: string;
  rotation: string;
  duration: number;
  delay?: number;
  distance?: number;
  className?: string;
  doesExist: (menuItems: MenuItemType[]) => boolean;
};

export const MENU_ITEM_DECORS: Record<"Travel" | "GiftCards" | "Hotel" | "Discounts" | "TopUp", DecorSelection> = {
  Travel: {
    main: TicketDecor,
    secondary: EarnedTag,
    doesExist: (menuItems) => menuItems.some((menuItem) => menuItem.type === "Travel"),
    x: "-start-1/6 lg:start-5/8",
    y: "top-1/5 lg:top-2/7",
    rotation: "ltr:rotate-3 -rotate-3",
    className: "max-lg:opacity-15",
    duration: 5.5,
  },
  GiftCards: {
    main: GiftcardsDecor,
    secondary: UnlockedCard,
    doesExist: (menuItems) => menuItems.some((menuItem) => menuItem.type === "GiftCards"),
    x: "start-1/3 lg:start-5/12",
    y: "top-3/4 lg:top-5/8",
    rotation: "ltr:rotate-10 -rotate-10",
    duration: 6,
    delay: 2.5,
    distance: -10,
  },
  Hotel: {
    main: HotelDecor,
    secondary: FastTag,
    doesExist: (menuItems) => menuItems.some((menuItem) => menuItem.type === "Hotel"),
    x: "start-0 lg:start-1/5",
    y: "top-3/4 lg:top-5/8",
    rotation: "ltr:-rotate-3 rotate-3",
    duration: 5,
    delay: 3,
  },
  Discounts: {
    main: DiscountsDecor,
    secondary: StarHolder,
    doesExist: (menuItems) => menuItems.some((menuItem) => menuItem.type === "Discounts"),
    x: "start-2/3 lg:start-4/6",
    y: "top-0 lg:top-1/12",
    rotation: "ltr:rotate-15 -rotate-15",
    className: "max-lg:opacity-15",
    duration: 3.5,
    delay: 0.6,
    distance: -6,
  },
  TopUp: {
    main: PaymentsDecor,
    secondary: TreatChip,
    doesExist: (menuItems) => menuItems.some((menuItem) => menuItem.type === "TopUp"),
    x: "start-3/4 lg:start-5/6",
    y: "top-3/4 lg:top-3/8",
    rotation: "ltr:-rotate-10 rotate-10",
    duration: 4.5,
    delay: -1.8,
  },
};
